const todoState = {
    todos: [],
    todoFilter: 'all',
};

export default todoState;
